module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-lower-section"
  }, [_c('div', {
    staticClass: "custom-lower-section__header"
  }, [_vm._v(_vm._s(_vm.props.header))]), _vm._l((_vm.props), function(content) {
    return _c('div', [_c('div', {
      staticClass: "custom-lower-section__section"
    }, [_c('div', {
      staticClass: "custom-lower-section__section-left"
    }, [_c('div', {
      staticClass: "custom-lower-section__section-background",
      style: ({
        backgroundImage: 'url(' + content.image + ')'
      })
    })]), _c('div', {
      staticClass: "custom-lower-section__section-right"
    }, [_c('div', {
      staticClass: "custom-lower-section__section-textbox"
    }, [_c('div', {
      staticClass: "custom-lower-section__section-title"
    }, [_vm._v(_vm._s(content.title))]), _c('div', {
      staticClass: "custom-lower-section__section-body",
      domProps: {
        "innerHTML": _vm._s(content.body)
      }
    }, [_vm._v(_vm._s(content.body))])])])]), _c('div', {
      staticClass: "divider"
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf4d34bc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-lower-section/custom-text-image.pug
// module id = 614
// module chunks = 1